module.exports = __webpack_public_path__ + "img/A_logo.15ba4638.png";